import { BLACK, UNIT } from "../../constants/configuration";
const getStyles = () => {
  return {
    btnStyle: {
      borderRadius: UNIT * 2,
      fontSize: UNIT * 0.75,
      fontFamily: "sans-serif",
      height: UNIT * 2.1875,
      fontWeight: 600,
    },
    broderStyle: {
      border: "1px solid #6A6A6A",
      margin: `${UNIT * 0.875}px 0px`,
    },
    forgetPasswordStyle: {
      fontSize: UNIT * 0.75,
      color: BLACK,
      textDecoration: "underline",
      fontWeight: 500,
    },
    closeButton: {
      opacity: 1,
      fontWeight: 300,
      fontSize: "xx-large",
    },
    container: {
      padding: "32px 40px",
      flexDirection: "column",
      alignItems: "center",
      gap: "40px",
      maxWidth: "358px",
      maxHeight: '98vh',
      overflowY: 'auto'
    },
    close: {
      cursor: "pointer",
      float: "right",
      position: "absolute",
      right: "20px",
      top: "20px",
    },
  };
}
export default getStyles;
